import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="bg-indigo-600 text-white p-4 flex justify-between">
      <h1 className="font-bold text-xl">HRMS Lite</h1>

      <div className="space-x-4">
        <Link to="/" className="hover:underline">Dashboard</Link>
        <Link to="/employees" className="hover:underline">Employees</Link>
        <Link to="/attendance" className="hover:underline">Attendance</Link>
        <Link to="/summary">Summary</Link>
      </div>
    </nav>
  );
}
